<!--
    @不参与审核的领导首页-快捷应用-项目
-->
<template>
	<div class="leader_app">
		<div class="item" :title="data.systemName"  @click.stop="itemHandle(1,data)">
			<div class="bg">
				<div class="delete" v-if="funDeleteFlag" @click.stop="itemHandle(2,data)"></div>
				<img :src="data.attachments?fileServerUrl+data.attachments[0].filePath:myImg" alt="" :onerror="defaultImg">
			</div>
			<p>{{data.systemName}}</p>
		</div>
	</div>
</template>

<script>
import myImg from '../../../../assets/images/home/changdi.png'
import {apiwbconveniententrancedeleteCustomize,apijwtToJsgc,apijwtToZfcg} from '@/server/common';
export default {
	props:{
		data:{
			type:Object,
			default:function(){
				return {};
			}
		},
		fileServerUrl:{
			type:String,
			default:''
		},
		funDeleteFlag:{
			type:Boolean,
			default:false
		}
	},
	data(){
		return {
			myImg:myImg,
			defaultImg:'this.src="'+myImg+'"'
		}
	},
	methods:{
		itemHandle(type,arg){
			if(type==1){
				if(arg.systemType==1){
					apijwtToJsgc({redUrl:arg.systemUrl,title:arg.systemName,field2:arg.systemTypeName,jwtType:arg.jwtType}).then(({data})=>{
						if(data.code=='1'){
							if(arg.jwtType==1){
								addPanel(arg.systemName,data.data)
							}else{
								window.open(data.data);
							}
						}else{
							this.$alert(data.msg);
						}
					})
				}
				if(arg.systemType==2){
					apijwtToZfcg({redUrl:arg.systemUrl,title:arg.systemName,field2:arg.systemTypeName,jwtType:arg.jwtType}).then(({data})=>{
						if(data.code=='1'){
							if(arg.jwtType==1){
								addPanel(arg.systemName,data.data)
							}else{
								window.open(data.data);
							}
						}else{
							this.$alert(data.msg);
						}
					})
				}
			}else if(type==2){
				this.$confirm('是否删除本条记录？','提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
					apiwbconveniententrancedeleteCustomize({id:arg.id,systemConfigId:arg.systemConfigId}).then(({data})=>{
						if(data.code=='1'){
							// this.APIwbconveniententranceconvenientList();
							this.$emit('addfnclose');
						}else{
							this.$message.error(data.msg)
						}
					})
				}).catch(()=>{})
			}
		}
	}
}
</script>

<style lang="less" scoped>
.leader_app{
	.item{
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		margin: 0 10px 30px 10px;
		.bg{
			width: 60px;
			height: 60px;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			.delete{
				position: absolute;
				width: 12px;
				height: 12px;
				border-radius: 50%;
				background: red;
				right: 0;
				top: 0;
				color: #ffffff;
				text-align: center;
				line-height: 12px;
				&:after{
					content: '';
					width: 6px;
					height: 2px;
					background: #ffffff;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%,-50%);
				}
			}
			img{
				width: 60px;
				height: 60px;
			}
		}
		p{
			text-align: center;
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			margin-top: 10px;
		}
	}
	// .item:nth-child(5n+1){
	// 	.bg{
	// 		background: #FFF0F0;
	// 	}
	// }
	// .item:nth-child(5n+2){
	// 	.bg{
	// 		background: #FFF1E8;
	// 	}
	// }
	// .item:nth-child(5n+3){
	// 	.bg{
	// 		background: rgba(52,190,62,0.1);
	// 	}
	// }
	// .item:nth-child(5n+4){
	// 	.bg{
	// 		background: rgba(0,137,255,0.1);
	// 	}
	// }
	// .item:nth-child(5n+5){
	// 	.bg{
	// 		background: rgba(210,63,222,0.1);
	// 	}
	// }
}
</style>
